import addCustomTextColor from './add-custom-text-color';
import addCustomGradient from './add-custom-gradient';

export default {
  addCustomTextColor,
  addCustomGradient,
};
